/* tpx (23.10.2026) - miscare "2026" pentru TotalPantofi.ro. Vezi tpx.css pentru reguli si oprire (?tpx=0).
   Fiecare modul e izolat in safe() si se opreste singur daca elementele nu exista pe pagina. Nu modifica logica de cos/filtre/produs. */
(function () {
  'use strict';
  if (window.__tpx) return;
  if (/[?&](tpx|tps)=0(&|$)/.test(location.search)) { document.documentElement.classList.remove('tpx-pre'); return; }
  try { if (localStorage.getItem('tpx_off') === '1') { document.documentElement.classList.remove('tpx-pre'); return; } } catch (e) {}
  window.__tpx = 1;

  var doc = document, root = doc.documentElement;
  function mq(q) { try { return !!(window.matchMedia && matchMedia(q).matches); } catch (e) { return false; } }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  var nav = navigator || {};
  var lite = !!((nav.connection && nav.connection.saveData) || (nav.deviceMemory && nav.deviceMemory <= 2) || (nav.hardwareConcurrency && nav.hardwareConcurrency <= 2));
  var SKIP = String(window.__tpxSkip || '').split(','), mid = 0;     /* doar pentru diagnostic: window.__tpxSkip = '3,5' sare peste modulele cu numarul respectiv */
  function safe(f) { mid++; if (SKIP.indexOf(String(mid)) >= 0) return; try { return f(); } catch (e) { if (window.__tpxDebug) { try { console.warn('[tpx]', e); } catch (x) {} } } }
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || doc).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  var raf = window.requestAnimationFrame ? function (f) { return requestAnimationFrame(f); } : function (f) { return setTimeout(f, 16); };

  root.classList.add('tpx');
  if (reduce) root.classList.add('tpx-rm');
  if (lite) root.classList.add('tpx-lite');
  if (fine) root.classList.add('tpx-fine');

  /* ---------------------------------------------------------------- 1. AURORA */
  safe(function () {
    var home = $('.tp-home');
    if (!home || $('.tpx-aurora', home)) return;
    var a = doc.createElement('div');
    a.className = 'tpx-aurora';
    a.setAttribute('aria-hidden', 'true');
    a.innerHTML = '<i></i><i></i><i></i>';
    home.insertBefore(a, home.firstChild);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { a.classList.toggle('is-paused', !en[0].isIntersecting); }).observe(a);
    }
  });

  /* ----------------------------------------------------- 2. TITLU CINETIC */
  safe(function () {
    var h = $('.tp-hero h1');
    if (!h || h.classList.contains('tpx-split')) { root.classList.remove('tpx-pre'); return; }
    if (reduce) { root.classList.remove('tpx-pre'); return; }
    var n = 0;
    function word(txt) {
      var w = doc.createElement('span'); w.className = 'tpx-w'; w.setAttribute('aria-hidden', 'true');
      var i = doc.createElement('span'); i.className = 'tpx-wi'; i.style.setProperty('--i', String(n++));
      i.textContent = txt; w.appendChild(i); return w;
    }
    h.setAttribute('aria-label', h.textContent.replace(/\s+/g, ' ').trim());
    [].slice.call(h.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = doc.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) frag.appendChild(doc.createTextNode(' '));
          else if (/^[.,!?:;]+$/.test(p)) frag.appendChild(doc.createTextNode(p));
          else frag.appendChild(word(p));
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.classList.contains('tp-accent')) {
        var w = doc.createElement('span'); w.className = 'tpx-w';
        var i = doc.createElement('span'); i.className = 'tpx-wi'; i.style.setProperty('--i', String(n++));
        node.parentNode.replaceChild(w, node); w.appendChild(i); i.appendChild(node);
      }
    });
    h.classList.add('tpx-split');
    raf(function () { root.classList.remove('tpx-pre'); });
  });
  setTimeout(function () { root.classList.remove('tpx-pre'); }, 1800);

  /* ------------------------------------------------ 3. ADANCIME (hero card) */
  safe(function () {
    var vis = $('.tp-hero-visual'), fr = $('.tp-hero-frame');
    if (!vis || !fr || reduce) return;
    var tx = 0, ty = 0, cx = 0, cy = 0, going = 0, gyro = false;
    function step() {
      going = 0;
      cx += (tx - cx) * .2; cy += (ty - cy) * .2;
      vis.style.setProperty('--tpx-rx', cx.toFixed(3));
      vis.style.setProperty('--tpx-ry', cy.toFixed(3));
      if (Math.abs(tx - cx) > .01 || Math.abs(ty - cy) > .01) going = raf(step);
    }
    function kick() { if (!going) going = raf(step); }
    vis.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var r = fr.getBoundingClientRect();
      var nx = ((e.clientX - r.left) / r.width - .5) * 2, ny = ((e.clientY - r.top) / r.height - .5) * 2;
      tx = clamp(nx, -1, 1) * 5; ty = clamp(ny, -1, 1) * 4;
      fr.style.setProperty('--tpx-gx', (e.clientX - r.left) + 'px');
      fr.style.setProperty('--tpx-gy', (e.clientY - r.top) + 'px');
      fr.classList.add('is-live'); kick();
    }, { passive: true });
    vis.addEventListener('pointerleave', function () { tx = 0; ty = 0; fr.classList.remove('is-live'); kick(); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { vis.classList.toggle('is-away', !en[0].isIntersecting); }).observe(vis);
    }
    /* telefon: inclinare dupa miscarea telefonului (Android; pe iOS cere permisiune, deci nu pornim) */
    if (!fine && 'DeviceOrientationEvent' in window && typeof window.DeviceOrientationEvent.requestPermission !== 'function') {
      var t0 = 0;
      window.addEventListener('deviceorientation', function (e) {
        if (vis.classList.contains('is-away') || e.gamma == null) return;
        var now = performance.now(); if (now - t0 < 40) return; t0 = now;
        if (!gyro) { gyro = true; fr.classList.add('is-live'); }
        tx = clamp(e.gamma / 28, -1, 1) * 4; ty = clamp(((e.beta || 50) - 50) / 28, -1, 1) * 3;
        fr.style.setProperty('--tpx-gx', (50 + tx * 10) + '%'); fr.style.setProperty('--tpx-gy', (35 + ty * 10) + '%');
        kick();
      }, { passive: true });
    }
  });

  /* ---------------------------------------- 4. COREOGRAFIE LA DERULARE */
  safe(function () {
    if (!('IntersectionObserver' in window) || reduce) return;
    var vh = window.innerHeight || 800;
    var proxy = typeof WeakMap === 'function' ? new WeakMap() : null;   /* elementul observat -> elementul animat (cand cel animat e decupat si IO nu l-ar vedea) */
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        var tgt = (proxy && proxy.get(x.target)) || x.target;
        tgt.classList.add('tpx-in'); io.unobserve(x.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    function arm(sel, variant, stagger) {
      $$(sel).forEach(function (el, i) {
        if (el.classList.contains('tpx-rv') || el.closest('.te-reveal, .scroll-trigger, .tpx-rv')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92) return;                 /* deja in ecran: nu ascundem nimic */
        el.classList.add('tpx-rv'); if (variant) el.classList.add(variant);
        el.style.setProperty('--tpx-i', String(stagger ? Math.min(i % 6, 5) : 0));
        if (variant === 'tpx-rv--mask' && el.parentElement && proxy) { proxy.set(el.parentElement, el); io.observe(el.parentElement); }
        else io.observe(el);
      });
    }
    arm('.tp-cat-head', 'tpx-rv--line', false);
    $$('.tp-marq-wrap').forEach(function (w) {
      if (w.closest('.tp-brands')) return;
      if (w.getBoundingClientRect().top < vh * 0.92) return;
      w.classList.add('tpx-cards');
      $('.tp-card', w).slice(0, 8).forEach(function (c, i) { c.classList.add('tpx-c'); c.style.setProperty('--k', String(i)); });
      io.observe(w);
    });
    arm('.tp-feat', '', true);
    arm('.tp-brands-head', '', false);
    arm('.tp-anekke-copy', '', false);
    arm('.tp-final-cta > *', '', true);
    arm('.tp-trust-row li', '', true);
    arm('.tp-delivery-estimate', '', false);
    arm('.tp-product-specs', '', false);
    arm('.footer__content-top .footer-block', '', true);
  });

  /* (numaratoarea "1079 produse" a fost scoasa: fiecare schimbare de text declansa observatorii de mutatii ai temei si costa ~2 s de recalculare de stil) */

  /* ---------------------------------------------- 5. INDICATOR LICHID */
  function liquid(box, itemSel, isActive) {
    if (!box || box.classList.contains('tpx-liq')) return;
    box.classList.add('tpx-liq');
    var pill = doc.createElement('span'); pill.className = 'tpx-pill'; pill.setAttribute('aria-hidden', 'true');
    box.insertBefore(pill, box.firstChild);
    var placed = false, pending = 0;
    function place() {
      pending = 0;
      var items = $$(itemSel, box), act = null;
      for (var i = 0; i < items.length; i++) { if (isActive(items[i])) { act = items[i]; break; } }
      if (!act) { pill.classList.remove('is-on'); placed = false; return; }
      var br = box.getBoundingClientRect(), r = act.getBoundingClientRect();
      pill.style.setProperty('--x', (r.left - br.left) + 'px'); pill.style.setProperty('--y', (r.top - br.top) + 'px');
      pill.style.setProperty('--w', r.width + 'px'); pill.style.setProperty('--h', r.height + 'px');
      if (!placed) { placed = true; raf(function () { raf(function () { pill.classList.add('is-on'); }); }); }
    }
    function sched() { if (!pending) pending = raf(place); }
    place();
    box.addEventListener('click', sched); box.addEventListener('change', sched);
    if ('MutationObserver' in window) new MutationObserver(sched).observe(box, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed', 'class', 'checked'] });
    if ('ResizeObserver' in window) new ResizeObserver(sched).observe(box);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(sched);
    window.addEventListener('resize', sched, { passive: true });
  }
  safe(function () {
    liquid($('.tps-finder__seg'), 'button', function (b) { return b.getAttribute('aria-pressed') === 'true'; });
    $$('.tp-product-options fieldset').forEach(function (fs) {
      var lg = $('legend', fs);
      if (!lg || !/m[ăa]rime|size/i.test(lg.textContent)) return;
      liquid($('.tp-option-values', fs), '.tp-option-choice', function (l) { var i = $('input', l); return !!(i && i.checked); });
    });
  });

  /* ------------------------------------------------ 6. BUTOANE (unda + luciu) */
  safe(function () {
    var SEL = '.tp-btn-primary, .tp-main-atc, .tps-finder__cta, .tp-pitch-cta, .tp-sticky-atc button, .tp-sticky-atc a';
    function prep(el) {
      if (el.classList.contains('tpx-btn')) return;
      el.classList.add('tpx-btn');
      var cs = getComputedStyle(el); if (cs.position === 'static') el.style.position = 'relative';
    }
    $$(SEL).forEach(prep);
    doc.addEventListener('pointerdown', function (e) {
      var el = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true' || reduce) return;
      prep(el);
      var r = el.getBoundingClientRect(), s = doc.createElement('span');
      s.className = 'tpx-ripple'; s.style.left = (e.clientX - r.left) + 'px'; s.style.top = (e.clientY - r.top) + 'px';
      s.style.setProperty('--s', String(Math.ceil(Math.max(r.width, r.height) / 10) + 4));
      el.appendChild(s); setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 800);
    }, { passive: true });
  });

  /* -------------------------------------------------------------- 7. CURSOR */
  safe(function () {
    return; /* cursor personalizat scos (26.10.2026) - cursorul normal al browserului */
    var c = doc.createElement('div'); c.className = 'tpx-cursor'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = '<span></span>';
    doc.body.appendChild(c);
    var lab = c.firstChild, x = -100, y = -100, cx = -100, cy = -100, on = false, going = 0, snapEl = null, sx = 0, sy = 0;
    var lastEl = null;
    function tick() {
      going = 0;
      var tx = x, ty = y;
      if (snapEl) { tx = sx + (x - sx) * .2; ty = sy + (y - sy) * .2; }     /* "magnet": ramane aproape de centrul elementului */
      cx += (tx - cx) * .24; cy += (ty - cy) * .24;
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      if (Math.abs(tx - cx) > .2 || Math.abs(ty - cy) > .2) going = raf(tick);
    }
    function setSnap(el) {
      if (el === lastEl) return;
      lastEl = el; snapEl = null;
      if (el) {
        var r = el.getBoundingClientRect();
        if (r.width > 14 && r.width < 420 && r.height > 14 && r.height < 110) {
          snapEl = el; sx = r.left + r.width / 2; sy = r.top + r.height / 2;
          var br = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0;
          c.style.setProperty('--sw', (r.width + 12) + 'px'); c.style.setProperty('--sh', (r.height + 10) + 'px');
          c.style.setProperty('--sr', Math.min(br + 6, (r.height + 10) / 2) + 'px');
        }
      }
      var on2 = !!snapEl; if (c.classList.contains('is-snap') !== on2) c.classList.toggle('is-snap', on2);
    }
    window.addEventListener('scroll', function () { if (snapEl) setSnap(null); lastEl = null; }, { passive: true });
    function classify(t) {
      var link = t.closest && t.closest('a, button, summary, label, [role=button], select, input[type=checkbox], input[type=radio]');
      var text = t.closest && t.closest('input[type=text], input[type=search], input[type=email], input[type=tel], textarea');
      var look = t.closest && t.closest('.tp-app-card-visual, .tp-card-img, .tp-cat-banner, .tp-hero-photo');
      var zoom = t.closest && t.closest('.tp-pdp-gallery');
      var isT = !!text, isK = !!link && !text && !look && !zoom;
      if (c.classList.contains('is-text') !== isT) c.classList.toggle('is-text', isT);
      if (c.classList.contains('is-link') !== isK) c.classList.toggle('is-link', isK);
      setSnap(isK ? link : null);
      var l = look && !text ? 'Vezi' : zoom && !text ? 'Mărește' : '';
      if (lab.textContent !== l) lab.textContent = l;
      var isL = !!l; if (c.classList.contains('is-label') !== isL) c.classList.toggle('is-label', isL);
    }
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      if (!on) { on = true; cx = x; cy = y; c.classList.add('is-on'); }
      classify(e.target); if (!going) going = raf(tick);
    }, { passive: true });
    doc.addEventListener('pointerdown', function () { c.classList.add('is-down'); }, { passive: true });
    doc.addEventListener('pointerup', function () { c.classList.remove('is-down'); }, { passive: true });
    doc.documentElement.addEventListener('mouseleave', function () { on = false; c.classList.remove('is-on'); });
  });

  /* ---------------------------------------------- 8. ANTET (progres lectura) - animat de CSS, fara cod la derulare */
  safe(function () {
    if (!doc.body || !(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'))) return;
    var bar = doc.createElement('div'); bar.className = 'tpx-readbar'; bar.setAttribute('aria-hidden', 'true'); doc.body.appendChild(bar);
  });

  /* ------------------------------ 10. BANDA DE BRANDURI reactiva la derulare */
  safe(function () {
    if (reduce) return;
    var tracks = $$('.tp-brand-track, .tp-brands .tp-marq-track');
    if (!tracks.length) return;
    var last = window.pageYOffset || 0, v = 0, running = 0, visible = true, cache = null;
    function anims() {
      if (cache && cache.length) return cache;
      cache = [];
      tracks.forEach(function (t) { try { t.getAnimations().forEach(function (a) { cache.push(a); }); } catch (e) {} });
      return cache;
    }
    function loop() {
      var y = window.pageYOffset || 0, d = y - last; last = y;
      v += (d - v) * .14;
      var rate = (v < 0 ? -1 : 1) * (1 + Math.min(Math.abs(v) * .12, 4.5));
      if (Math.abs(v) < .05) rate = 1;
      var list = anims();
      for (var i = 0; i < list.length; i++) { try { list[i].playbackRate = rate; } catch (e) {} }
      if (Math.abs(v) > .05 && visible) running = raf(loop); else running = 0;
    }
    window.addEventListener('scroll', function () { if (!running && visible) running = raf(loop); }, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { visible = en.some(function (x) { return x.isIntersecting; }); });
      tracks.forEach(function (t) { io.observe(t); });
    }
  });

  /* ----------------------------------------- 15. BOKEH in jurul pantofului */
  safe(function () {
    var vis = $('.tp-hero-visual');
    if (!vis || $('.tpx-bk', vis) || reduce) return;
    var cfg = [ /* x, y, marime, adancime, culoare, z, intarziere */
      ['3%', '9%', '58px', 22, 'var(--tpx-orange)', 2, '0s'], ['82%', '76%', '34px', 30, 'var(--tpx-pink)', 2, '-2s'], ['90%', '40%', '76px', 14, 'var(--tpx-amber)', 0, '-4s'],
      ['2%', '70%', '40px', 26, 'var(--tpx-pink)', 0, '-1s'], ['44%', '-6%', '30px', 34, 'var(--tpx-orange)', 2, '-3s'], ['70%', '90%', '56px', 18, 'var(--tpx-orange)', 2, '-5s']
    ];
    cfg.forEach(function (c) {
      var i = doc.createElement('i'); i.className = 'tpx-bk'; i.setAttribute('aria-hidden', 'true');
      i.style.cssText = '--bx:' + c[0] + ';--by:' + c[1] + ';--bs:' + c[2] + ';--bd:' + c[3] + ';--c:' + c[4] + ';--bz:' + c[5] + ';--bt:' + c[6];
      vis.appendChild(i);
    });
  });

  /* ------------------------------------------------ 19. PERETE DE CUVINTE (v5) */
  /* Categorii + branduri ca poster tipografic. Fiecare rand e "justificat": latimea lui in em se masoara o singura data (canvas, fara layout),
     iar CSS-ul calculeaza marimea fontului din latimea containerului => niciun cuvant taiat, pe orice ecran. Cuvintele sunt linkuri reale. */
  safe(function () {
    if ($('.tpx-wall')) return;
    var after = $('.tp-home .tp-features') || $('.tp-home .tp-hero');
    if (!after) return;
    var CATS = [['Pantofi sport', '/collections/pantofi-sport'], ['Ghete', '/collections/ghete'], ['Casual', '/collections/pantofi-casual'],
      ['Eleganți', '/search?q=eleganti'], ['Sandale', '/search?q=sandale'], ['Adidași', '/search?q=adidasi']];
    var BRANDS = [['Skechers', '/collections/skechers'], ['Tamaris', '/collections/tamaris'], ['Rieker', '/collections/rieker'],
      ['Formazione', '/collections/formazione'], ['Franco Gerardo', '/collections/franco-gerardo'], ['Anekke', '/collections/anekke']];
    var ctx = null;
    try { ctx = doc.createElement('canvas').getContext('2d'); } catch (e) {}
    function items(list) {
      return list.map(function (x) {
        var up = x[0].toLocaleUpperCase('ro'), w = up.length * 0.66;
        if (ctx) { ctx.font = '800 100px "Bricolage Grotesque", Assistant, sans-serif'; w = ctx.measureText(up).width / 100; }
        return { u: up, h: x[1], w: w - up.length * 0.035 };            /* latimea in em, cu letter-spacing -.035em */
      });
    }
    function rowW(list) { var s = 0; list.forEach(function (i) { s += i.w; }); return s + (list.length - 1) * 0.4 + (2 * list.length - 2) * 0.3; }   /* + stelute + spatiu minim */
    function split(list, k) {                                            /* imparte cuvintele in k randuri de marime egala, cu latimi (in em) cat mai apropiate => marimi de font apropiate */
      var n = list.length, size = Math.ceil(n / k), best = null;
      function combos(arr, c, cb) { (function go(i, acc) { if (acc.length === c) { cb(acc); return; } for (var j = i; j < arr.length; j++) go(j + 1, acc.concat([arr[j]])); })(0, []); }
      function rec(rest, groups) {
        if (!rest.length) {
          var ws = groups.map(rowW), sp = Math.max.apply(0, ws) - Math.min.apply(0, ws);
          if (!best || sp < best.sp - 1e-9) best = { sp: sp, groups: groups };
          return;
        }
        var first = rest[0], others = rest.slice(1);
        combos(others, Math.min(size, rest.length) - 1, function (pick) {
          rec(others.filter(function (x) { return pick.indexOf(x) < 0; }), groups.concat([[first].concat(pick)]));
        });
      }
      rec(list, []);
      return best.groups;
    }
    var wall = null, narrow = window.matchMedia ? matchMedia('(max-width: 640px)') : null;
    function build() {
      var k = narrow && narrow.matches ? 3 : 2;
      var a = split(items(CATS), k), b = split(items(BRANDS), k), kk = 0;
      var rows = a.concat(b);
      var html = rows.map(function (r, ri) {
        var cells = r.map(function (it, ci) {
          var el = '<a class="tpx-w" href="' + it.h + '" style="--k:' + (kk++) + '"><span class="tpx-wt" data-t="' + it.u + '">' + it.u + '</span></a>';
          return ci < r.length - 1 ? el + '<i class="tpx-st" aria-hidden="true">✦</i>' : el;
        }).join('');
        return '<div class="tpx-row' + (ri === a.length ? ' tpx-row--sep' : '') + '" style="--w:' + rowW(r).toFixed(2) + ';--dir:' + (ri % 2 ? -1 : 1) + '">' + cells + '</div>';
      }).join('');
      if (!wall) {
        wall = doc.createElement('div'); wall.className = 'tpx-wall';
        wall.setAttribute('role', 'navigation'); wall.setAttribute('aria-label', 'Categorii și branduri');
        after.parentNode.insertBefore(wall, after.nextSibling);
      }
      wall.innerHTML = html;
      raf(function () {          /* calibrare: daca fontul real iese mai lat decat masurat, mareste --w al randului (o singura citire de layout) */
        $$('.tpx-row', wall).forEach(function (r) {
          var cw = r.clientWidth, sw = r.scrollWidth;
          if (cw && sw > cw) r.style.setProperty('--w', (parseFloat(r.style.getPropertyValue('--w')) * (sw / cw) * 1.015).toFixed(2));
        });
      });
    }
    var fontP = (doc.fonts && doc.fonts.load) ? Promise.race([doc.fonts.load('800 100px "Bricolage Grotesque"'), new Promise(function (r) { setTimeout(r, 1500); })]) : Promise.resolve();
    fontP.then(build, build);
    if (narrow && narrow.addEventListener) narrow.addEventListener('change', function () { if (wall) build(); });
  });

  /* ------------------------------------- 12. PAGINA DE PRODUS: lupa + ATC */
  safe(function () {
    if (!fine || reduce) return;
    $$('.tp-pdp-slide').forEach(function (sl) {
      var img = $('img', sl); if (!img) return;
      var t = 0;
      sl.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'mouse') return; clearTimeout(t); t = setTimeout(function () { sl.classList.add('tpx-zoom'); }, 160); });
      sl.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = sl.getBoundingClientRect();
        sl.style.setProperty('--tpx-zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        sl.style.setProperty('--tpx-zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }, { passive: true });
      sl.addEventListener('pointerleave', function () { clearTimeout(t); sl.classList.remove('tpx-zoom'); });
      sl.addEventListener('pointerdown', function () { clearTimeout(t); sl.classList.remove('tpx-zoom'); sl.classList.add('tpx-snap'); setTimeout(function () { sl.classList.remove('tpx-snap'); }, 450); }, true);
    });
  });
  safe(function () {
    var atc = $('.tp-main-atc');
    if (!atc || !('MutationObserver' in window) || reduce) return;
    var last = atc.textContent;
    new MutationObserver(function () {
      var now = atc.textContent; if (now === last) return; last = now;
      atc.classList.remove('tpx-shine'); void atc.offsetWidth; atc.classList.add('tpx-shine');
      setTimeout(function () { atc.classList.remove('tpx-shine'); }, 1000);
    }).observe(atc, { childList: true, characterData: true, subtree: true });
  });

  /* ------------------------------------------------- 13. FINALUL PAGINII */
  safe(function () {
    var foot = $('footer.footer, .footer');
    if (!foot || $('.tpx-finale')) return;
    var f = doc.createElement('div'); f.className = 'tpx-finale'; f.setAttribute('aria-hidden', 'true');
    var items = ['Peste 4000 de modele în stoc', 'Livrare gratuită', 'Retur în 14 zile', 'Produse 100% originale', 'Plată la livrare sau cu cardul', 'Curier sau Easybox'];
    var rail = items.concat(items).concat(items).concat(items).map(function (t) { return '<span>' + t + '</span>'; }).join('');
    f.innerHTML = '<b class="tpx-finale__word">TotalPantofi.ro</b><div class="tpx-finale__rail">' + rail + '</div>';
    foot.parentNode.insertBefore(f, foot);
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { f.classList.add('tpx-in'); io.disconnect(); } }, { threshold: 0.25 });
      io.observe(f);
    } else { f.classList.add('tpx-in'); }
  });

  /* ------------------------------------------------ 14. VIBRATIE (telefon) */
  safe(function () {
    if (fine || !nav.vibrate) return;
    doc.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.tps-opt, .tps-chip, .tps-finder__seg button, .tp-option-choice')) { try { nav.vibrate(8); } catch (x) {} }
    }, { passive: true });
  });
})();
